import axios from "axios";
import { Message } from "element-ui";
import { getToken, setToken } from "./auth";

const url = process.env.VUE_APP_BASE_LOGIN;

// Create axios instance
const service = axios.create({
  baseURL: `${url}/`,
  timeout: 60 * 10 * 1000
});

service.interceptors.request.use(
  config => {
    // const token = getToken();
    // if (token.token) {
    //   config.headers["Authorization"] = "Bearer " + getToken().token; // Set JWT token
    // }

    return config;
  },
  error => {
    Promise.reject(error);
    window.location.reload();
  }
);

// response pre-processing
service.interceptors.response.use(
  response => {
    // if (response.headers.authorization) {
    //   setToken(response.headers.authorization);
    //   response.data.token = response.headers.authorization;
    // }

    return response.data;
  },
  error => {
    console.log("err" + error); // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
